// extracted by mini-css-extract-plugin
export default {"option":"SocialMedia_option__Yv4cL","icon":"SocialMedia_icon__og1WS"};